import { UploadImageBox } from './UploadImageBox';
export default UploadImageBox;
